<template>
  <modal
    :isModalStatic="true"
    :isHideHeaderCloseButton="true"
    :isHideFooter="true"
    modalSizeCssClass="lg"
    componentName="RegisterModal">
    <template v-slot:body>
      <component
        :is="dynamicComponent"
        :mobile-phone="mobilePhone"
        ref="registerModal"
        @cancel="closeModal('RegisterModal')"
        @invoke-confirm-order="$emit('invoke-confirm-order')" />
    </template>
  </modal>
</template>

<script>
import { closeModal } from '@/helpers/modal';
import { getState } from '@/helpers/vuex';
import Modal from '@/components/common/common-modal.vue';
import Step1 from '@/components/desktop/step1/register-info-modal/step1.vue';
import Step2 from '@/components/desktop/step1/register-info-modal/step2.vue';

export default {
  name: 'register-info-modal',
  inject: ['$validator'],
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
  },
  components: {
    Modal,
    Step1,
    Step2,
  },
  computed: {
    dynamicComponent: getState('DynamicComponents', 'registerMethod'),
  },
  methods: {
    closeModal,
  },
};
</script>
